import { defineStore } from "pinia";
import { mande } from "mande";

interface GeneralOptions {
    contact_email: string;
    contact_phone: string;
    adress_label: string;
    adress_url: string;
    instagram_url: string;
    facebook_url: string;
    twitter_url: string;
}

interface Page {
    id: number;
    slug: string;
    title: string;
    route_name: string;
    relative_url: string;
    show_in_header: boolean;
    show_in_footer: boolean;
    order: string;
}

interface Navigation {
    header: {
        sticky: boolean;
    };
    slideout: {
        visible: boolean;
    };
}

const api = mande("/api");

export const useAppStore = defineStore("app", {
    state: () => {
        return {
            general: undefined,
            pages: [],
            navigation: {
                header: {
                    sticky: false,
                },
                slideout: {
                    visible: false,
                },
            },
        } as { general?: GeneralOptions; pages: Page[]; navigation: Navigation };
    },

    actions: {
        async getGeneralOptions() {
            const general = await api.get("general");

            this.general = general as unknown as GeneralOptions;

            return Promise.resolve(this.general);
        },

        async indexPages() {
            const pages = await api.get("pages");

            this.pages = pages as unknown as Page[];

            return Promise.resolve(this.pages);
        },
    },
});
